// removed by extract-text-webpack-plugin
module.exports = {"columnTag":"index__columnTag___14k9i","restriction":"index__restriction___1ZXjA"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ui/DragSources/index.less
// module id = 1056
// module chunks = 3